import { StoryElementType } from 'webapp/enums/enums';

import StoryElementBase from 'webapp/models-custom/story-element/base';

export default class StoryElementCompareGranulationLabel extends StoryElementBase {
	type = StoryElementType.COMPARE_GRANULATION_LABEL;
	longTitle = 'Date label';

	openEdit(_node: HTMLElement): void {
		this.openAdvanced();
	}

	fillElementContent(node: HTMLElement): void {
		const text = this.comparePoint?.granulationLabel?.labelLong || '<unknown>';
		node.textContent = text;
	}
}
